// The one way a failed mutation reaches a toast, ported from vouchers.
//
// The server's own words never go on screen raw: the copy comes from
// friendly-error.ts, keyed on the problem's code, with status and request id
// one click away. Sticky for an ApiError, so the request id can be copied
// before it goes.

import { toast } from "@pej/kore/components";
import { ApiError, type FieldErrorSpec } from "@/api/error";
import { ErrorToastContent } from "./error-toast-content";

export interface ToastMutationErrorOptions {
    /** Enables links into the workspace (the toast mounts outside it). */
    workspaceId?: string;
    /** Field errors the form could not place on a field. */
    unmapped?: ReadonlyArray<Pick<FieldErrorSpec, "path" | "message">>;
}

export function toastMutationError(title: string, err: unknown, options: ToastMutationErrorOptions = {}): void {
    if (err instanceof ApiError) {
        toast.error(title, {
            description: <ErrorToastContent err={err} unmapped={options.unmapped} workspaceId={options.workspaceId} />,
            duration: Number.POSITIVE_INFINITY,
        });
        return;
    }
    // Network failure or a throw on our side: no status, no request id.
    toast.error(title, {
        description: err instanceof Error ? err.message : String(err),
        duration: 6000,
    });
}
